export default {"src":"/_next/static/media/greenlake-medical.62a699e8.svg","height":210,"width":791,"blurWidth":0,"blurHeight":0};